var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"primary","fab":"","outlined":"","small":"","to":_vm.pathPrintPage,"target":"_blank"},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-printer")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }